<template>
<div class="chapter">
<div class="inner_page">
<p class="head">CONTENTS</p>
<p class="toc"><a href="#/Foreword">Foreword, by Dr. Mark Horton</a></p>
<p class="toc"><a href="#/Preface">Preface</a></p>
<p class="toc"><a href="#/Introduction">Introduction</a></p>
<p class="toc1"><a href="#/Part1"><b>P<span class="small">ART</span> I. T<span class="small">HE</span> H<span class="small">ISTORY</span></b></a></p>
<p class="toc"><a href="#/Chapter1">1. The Push for Colonization</a></p>
<p class="toc"><span href="#/Chapter2" title="Link target outside of Sample">2. The First Voyage: 1584</span></p>
<p class="toc"><span href="#/Chapter3" title="Link target outside of Sample">3. The Second Voyage: 1585–1586</span></p>
<p class="toc"><span href="#/Chapter4" title="Link target outside of Sample">4. The Resupply Mission: 1586</span></p>
<p class="toc"><span href="#/Chapter5" title="Link target outside of Sample">5. The “Lost” Colony: 1587</span></p>
<p class="toc"><span href="#/Chapter6" title="Link target outside of Sample">6. John White’s Return Voyage: 1590</span></p>
<p class="toc"><span href="#/Chapter7" title="Link target outside of Sample">7. Later Attempts: The Search (or Lack Thereof) for the Colonists</span></p>
<p class="toc1"><span href="#/Part2" title="Link target outside of Sample"><b>P<span class="small">ART</span> II. A<span class="small">RCHAEOLOGY</span></b> </span></p>
<p class="toc"><span href="#/Chapter8" title="Link target outside of Sample">8. Native Life</span></p>
<p class="toc"><span href="#/Chapter9" title="Link target outside of Sample">9. Introduction to Archaeology</span></p>
<p class="toc"><span href="#/Chapter10" title="Link target outside of Sample">10. The Real Search Begins: November 2009</span></p>
<p class="toc"><span href="#/Chapter11" title="Link target outside of Sample">11. Daub Gone It: 2010</span></p>
<p class="toc"><span href="#/Chapter12" title="Link target outside of Sample">12. Mysterious Woman: 2011</span></p>
<p class="toc"><span href="#/Chapter13" title="Link target outside of Sample">13. Guns and Brandy</span></p>
<p class="toc"><span href="#/Chapter14" title="Link target outside of Sample">14. Pay Dirt</span></p>
<p class="toc"><span href="#/Chapter15" title="Link target outside of Sample">15. The Earth Listens</span></p>
<p class="toc"><span href="#/Chapter16" title="Link target outside of Sample">16. Survivors’ Camp</span></p>
<p class="toc"><span href="#/Chapter17" title="Link target outside of Sample">17. Theories</span></p>
<p class="toc1"><span href="#/Glossary" title="Link target outside of Sample">Algonquian Glossary</span></p>
<p class="toc"><span href="#/Bibliography" title="Link target outside of Sample">Bibliography</span></p>
<p class="toc"><span href="#/Author" title="Link target outside of Sample">About the Author</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Contents.vue?b63d8904